import React from "react";
import "./style.css";
import Resume from "../../assets/pdf/Resume.pdf"
import { motion } from "framer-motion";
import NextButton from "../../NextButton";


function About() {

    return (<motion.div
        initial={{ opacity: 0, x: 0, y: 200 }}
        animate={{ opacity: 1, x: 0, y: 0 }}
        exit={{ opacity: 0, x: 0, y: -200 }}
        transition={{ duration: 0.5 }}
    >
        <article id="about">
            <div className="row">
                <section className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div id="portrait-container">
                        <motion.div
                            id="motionDivTwo"
                            animate={{ borderRadius: ["38% 68% 32% 62%", "58% 38% 72% 42%", "45% 35% 55% 65%"] }}
                            transition={{
                                duration: 12,
                                repeat: Infinity,
                                repeatType: "reverse",
                                ease: "easeInOut"
                            }}
                        >
                            <motion.div
                                id="motionDivOne"
                                animate={{ borderRadius: ["38% 68% 32% 62%", "55% 35% 75% 55%", "58% 38% 72% 42%"] }}
                                transition={{
                                    duration: 10,
                                    repeat: Infinity,
                                    repeatType: "reverse",
                                    ease: "easeInOut"
                                }}
                            >
                                <motion.img src={process.env.PUBLIC_URL + "/images/bw-portrait.jpg"} alt="Portrait of Manuel" id="portrait-image"
                                    animate={{ borderRadius: ["35% 45% 50% 75%", "38% 68% 32% 62%", "58% 38% 72% 42%"] }}
                                    transition={{
                                        duration: 15,
                                        repeat: Infinity,
                                        repeatType: "reverse",
                                        ease: "easeInOut"
                                    }}
                                ></motion.img>
                            </motion.div>
                        </motion.div>
                    </div>
                </section>
                <section className="col-12 col-sm-12 col-md-6 col-lg-6">
                    <div id="about-me">
                        <h1>About Me</h1>
                        <hr></hr>
                        <p>
                            Motivated Software Developer with over 3 years of experience in coding, specializing in creating efficient and accessible solutions. Skilled in time management, problem-solving, and collaboration to deliver projects on time. Passionate about learning new technologies and eager to tackle challenging opportunities to enhance my skills.
                        </p>
                        <address>
                            <a href="tel:+16477042246" aria-label="Call Manuel Leung Chen">
                                Phone: (647)-704-2246
                            </a>
                        </address>
                        <address>
                            <a href="mailto:manuel.leungchen@gmail.com" aria-label="Email Manuel Leung Chen">
                                Email: manuel.leungchen@gmail.com
                            </a>
                        </address>
                    </div>
                    <div className="row" id="social">
                        <div className="col-3">
                            <a href="https://www.linkedin.com/in/manuel-leung-chen/" rel="noopener noreferrer" target="_blank" title="Connect With Me on Linkedin">
                                <i className="fab fa-linkedin" /></a>
                        </div>
                        <div className="col-3">
                            <a href="https://github.com/manuelleungchen" rel="noopener noreferrer" target="_blank" title="View My Repositories">
                                <i className="fab fa-github" /></a>
                        </div>
                        <div className="col-3">
                            <a href="https://discord.com/users/834973242548027403" rel="noopener noreferrer" target="_blank" title="Message Me on Discord">
                                <i className="fab fa-discord" /></a>
                        </div>
                        <div className="col-3">
                            <a href="https://www.instagram.com/mleungc/" rel="noopener noreferrer" target="_blank" title="Follow Me on Instagram">
                                <i className="fab fa-instagram" /></a>
                        </div>
                        <div className="col-12" id="resume-link-div">
                            <a className="btn btn-secondary" href={Resume} rel="noopener noreferrer" target="_blank" title="View Resume">
                                <i className="far fa-file-pdf" />Resume</a>
                        </div>
                    </div>
                </section>
                <section className="col-12">
                    <hr></hr>
                    <div id="skills">
                        <h2>Skills</h2>
                        <div className="row" id="skill-icons">
                            <div className="col-3 col-md-2 col-lg-2 col-xl-1"><i className="fab fa-html5" /><p>HTML 5</p></div>
                            <div className="col-3 col-md-2 col-lg-2 col-xl-1"><i className="fab fa-css3-alt" /><p>CSS</p></div>
                            <div className="col-3 col-md-2 col-lg-2 col-xl-1"><i className="fab fa-js-square" /><p>JavaScript</p></div>
                            <div className="col-3 col-md-2 col-lg-2 col-xl-1"><i className="fab fa-node-js" /><p>Node.js</p></div>
                            <div className="col-3 col-md-2 col-lg-2 col-xl-1"><i className="fab fa-npm" /><p>NPM</p></div>
                            <div className="col-3 col-md-2 col-lg-2 col-xl-1"><i className="fab fa-react" /><p>React.js</p></div>
                            <div className="col-3 col-md-2 col-lg-2 col-xl-1"><i className="fas fa-universal-access" /><p>Accessability</p></div>
                            <div className="col-3 col-md-2 col-lg-2 col-xl-1"><i className="fab fa-github" /><p>Github</p></div>
                            <div className="col-3 col-md-2 col-lg-2 col-xl-1"><i className="fas fa-mobile-alt" /><p>Responsive</p></div>
                            <div className="col-3 col-md-2 col-lg-2 col-xl-1"><i className="fas fa-database" /><p>MongoDB</p></div>
                            <div className="col-3 col-md-2 col-lg-2 col-xl-1"><i className="fas fa-server" /><p>Heroku</p></div>
                            <div className="col-3 col-md-2 col-lg-2 col-xl-1"><i className="fas fa-database" /><p>MySQL</p></div>
                        </div>
                    </div>
                </section>
            </div>
            <NextButton nextPage="portfolio" ></NextButton>
        </article>
    </motion.div>
    )
}

export default About;